import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Create client only if configured
export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;

export const isSupabaseConfigured = () => !!supabase;

// Helper to call Supabase Edge Functions
export const callEdgeFunction = async (functionName, body = {}) => {
  if (!supabase) throw new Error('Supabase not configured');

  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Not authenticated');

  // Use Supabase's built-in functions.invoke which handles auth automatically
  const { data, error } = await supabase.functions.invoke(functionName, {
    body: body,
  });

  if (error) {
    throw new Error(error.message || 'Function call failed');
  }

  return data;
};
